<template>
  <div class="page">
    <dashboard-header></dashboard-header>
    
    <div class="content">
      <div class="container-fluid">
        <div class="row row-deck row-cards">
          <div class="col-md-12">
            
            <div class="card">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <a :class="`nav-link ${selectedTab == 'screenshots' ? 'active' : ''}`" href="#nav-screenshots" @click.prevent="selectTab('screenshots')">Screenshot History</a>
                  </li>
                </ul>
              
              <div class="card-body">
                
                <div v-show="selectedTab=='campaigns'">
                  <h2>Campaigns Requiring Updates Between:
                    <input type="date" v-model="dtCampaignFrom" /> - <input type="date" v-model="dtCampaignTo" />
                  </h2>
                  
                  <paged-api-table
                    v-bind:columns="campaignColumns"
                    module="Campaigns"
                    module-id="id"
                    v-bind:include-relations="campaignRelation"
                    default-sort="startDate DESC"
                    v-bind:per-page="campaignPerPage">
                    </paged-api-table>
                </div>
                
                <div v-show="selectedTab=='screenshots'">
                  <h2>View screenshot history after and including:
                    <input type="date" v-model="dtScreenshotAfter" />
                  </h2>
                  
                  <paged-api-table
                    v-bind:columns="screenshotColumns"
                    v-bind:filter="screenshotFilter"
                    module="Search-Results"
                    module-id="id"
                    v-bind:include-relations="screenshotRelation"
                    default-sort="createdAt DESC"
                    v-bind:per-page="screenshotPerPage">
                    </paged-api-table>
                </div>
                
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
  import DashboardHeader from "./DashboardHeader.vue";
  import DashboardFooter from "./DashboardFooter.vue";
  import PagedApiTable from "./PagedApiTable.vue";
  
  export default {
    data() {
      return {
        selectedTab: "screenshots",
        
        campaignColumns: [
          { key: "client", "text": "Client", type: "String", sort: true },
          { key: "name", "text": "Campaign", type: "String", sort: true },
          { key: "startDate", "text": "Start Date", type: "Date", sort: true },
          { key: "endDate", "text": "End Date", type: "Date", sort: true },
          { key: "details", "text": "Details", type: "Route", route: "/client/:clientId" },
        ],
        campaignPerPage: 10,
        campaignRelation: [ "client" ],
        
        screenshotColumns: [
          { key: "createdAt", "text": "Created At", type: "DateTime", sort: true },
          { key: "client", "text": "Client", type: "String", sort: true, fnAsyncLoad: (item) => { return item.client.firstName + " " + item.client.lastName } },
          { key: "keyword", "text": "Keyword", type: "String", sort: true },
          { key: "status", "text": "Status", type: "String", sort: true },
          { key: "details", "text": "Details", type: "Route", route: "/client/:clientId" },
        ],
        screenshotPerPage: 10,
        screenshotFilter: this.getScreenshotFilter(""),
        screenshotRelation: [ "client" ],
        
        dtCampaignFrom: "",
        dtCampaignTo: "",
        dtScreenshotAfter: ""
      };
    },
    
    methods: {
      selectTab(newTab) {
        this.selectedTab = newTab;
      },
      
      getCampaignFilter() {
        
      },
      
      getScreenshotFilter(dtScreenshotAfter) {
        return {
          createdAt: {
            gte: (dtScreenshotAfter ? new Date(dtScreenshotAfter) : new Date()).toISOString()
          }
        };
      }
    },
    
    watch: {
      dtScreenshotAfter(to) {
        this.screenshotFilter = this.getScreenshotFilter(to);
      }
    },
    
    components: {
      DashboardHeader,
      DashboardFooter,
      PagedApiTable
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AutoScreenshots.vue